export const pressImageUrls = [
  {
    imgStyle: {
      maxWidth: '160px',
    },
    url: 'https://cdn-images.italist.com/image/upload/v1602061497/press/svg/harpers-bazaar.svg',
  },
  {
    imgStyle: {
      maxWidth: '200px',
    },
    url: 'https://cdn-images.italist.com/image/upload/v1602061497/press/svg/marie-claire-vector-logo.svg',
  },
  {
    imgStyle: {
      maxWidth: '250px',
    },
    url: 'https://cdn-images.italist.com/image/upload/v1602061497/press/svg/the-zoe-report.svg',
  },
  {
    imgStyle: {
      maxWidth: '130px',
    },
    url: 'https://cdn-images.italist.com/image/upload/v1602061497/press/svg/yahoo.svg',
  },
  {
    imgStyle: {
      maxWidth: '240px',
    },
    url: 'https://cdn-images.italist.com/image/upload/v1602061497/press/svg/who-what-wear.svg',
  },
  {
    imgStyle: {
      maxWidth: '150px',
    },
    url: 'https://cdn-images.italist.com/image/upload/v1602061497/press/svg/forbes.svg',
  },
];
